import Collapse from '../../../Components/HealthPlan/Collapse/Collapse';
// @ts-ignore
import styles from './EPrescriptionMedicamentWarnings.module.scss';
import { PrescriptionMedicament } from '../../../graphql/graphql';
import useTranslation from '../../../Hooks/useTranslation';
import React from 'react';

interface EPrescriptionMedicamentWarningsProps {
	item: PrescriptionMedicament;
}

const EPrescriptionMedicamentWarnings: React.FC<
	EPrescriptionMedicamentWarningsProps
> = ({ item }) => {
	const { t } = useTranslation();

	return (
		<>
			{item.hasIndicationLimitations && (
				<Collapse
					headerClassName={styles.wrapper}
					icon='/dist/icons/warning-triangle.svg'
					title='component.ePrescription.restrictionsIndication'>
					<div className={styles.collapseContent}>
						{item.indicationLimitations}
					</div>
				</Collapse>
			)}
			{item.hasSpecialityLimitations && (
				<Collapse
					headerClassName={styles.wrapper}
					icon='/dist/icons/warning-triangle.svg'
					title='component.ePrescription.limitationsOfExpertise'>
					<div className={styles.collapseContent}>
						{item.specialityLimitations}
					</div>
				</Collapse>
			)}
			{item.dopingTermItem && (
				<Collapse
					headerClassName={styles.wrapper}
					icon='/dist/icons/doping-icon.svg'
					title='component.ePrescription.dopingClean'>
					<div className={styles.collapseContent}>
						<span>{item.dopingTermItem.value}</span> -{' '}
						{item.dopingTermItem.name}
					</div>
				</Collapse>
			)}
			{(item.dispensingTermItem || item.limTermItem) && (
				<Collapse
					headerClassName={styles.wrapper}
					title='component.ePrescription.other'
					defaultOpen={true}>
					{item.dispensingTermItem && (
						<div className={styles.collapseContent}>
							<div className={styles.row}>
								<div className={styles.item}>
									<div className={styles.name}>
										{t('component.ePrescription.issue')}
									</div>
								</div>
							</div>
							<span>{item.dispensingTermItem.value}</span> -{' '}
							{item.dispensingTermItem.name}
						</div>
					)}
					{item.limTermItem && (
						<div className={styles.collapseContent}>
							<div className={styles.row}>
								<div className={styles.item}>
									<div className={styles.name}>
										{t('component.ePrescription.lim')}
									</div>
								</div>
							</div>
							<span>{item.limTermItem.value}</span> - {item.limTermItem.name}
						</div>
					)}
				</Collapse>
			)}
		</>
	);
};

export default EPrescriptionMedicamentWarnings;
